export default __webpack_public_path__ + "images/0x78c1b0c915c4faa5fffa6cabf0219da63d7f4cb8.png";